import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Location } from '@angular/common';
import { PortalBookingNode } from '@app/services/api/api.types';
import { TravelerInfoBlocks } from '@app/components/traveler-info/traveler-info.enum';

@Component({
  selector: 'booking-trip',
  templateUrl: './booking-trip.component.html',
  styleUrls: ['./booking-trip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingTripComponent {
  @Input() data: PortalBookingNode | null = null;

  private location = inject(Location);

  protected travelerFields = [
    TravelerInfoBlocks.FirstName,
    TravelerInfoBlocks.MiddleName,
    TravelerInfoBlocks.LastName,
    TravelerInfoBlocks.Gender,
    TravelerInfoBlocks.DateOfBirth,
    TravelerInfoBlocks.Citizenship,
    TravelerInfoBlocks.ExpiryDate,
  ];
  protected travelerAdditionalFields = [
    TravelerInfoBlocks.PassportNumber,
    TravelerInfoBlocks.Email,
    TravelerInfoBlocks.KnownTravelerNumber,
    TravelerInfoBlocks.RedressNumber,
  ];

  goBack() {
    this.location.back();
  }
}
